import {FC} from 'react';
import {useRecoilValue, useSetRecoilState} from 'recoil';

import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import {DeviceModelRow} from './DeviceModelRow';

import {deviceModelControlState, deviceModelsState} from '../../../../store/deviceModels/atoms';

interface ITableBodyContainer {
  rowsPerPage: number;
}

export const TableBodyContainer: FC<ITableBodyContainer> = ({rowsPerPage}) => {
  const {content} = useRecoilValue(deviceModelsState);
  const setOpenControl = useSetRecoilState(deviceModelControlState);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows = rowsPerPage - content.length;

  return (
    <TableBody>
      {content.map((row) => {
        return <DeviceModelRow key={row.id} row={row} setOpen={setOpenControl} />;
      })}
      {emptyRows > 0 && (
        <TableRow
          style={{
            height: 37 * emptyRows,
          }}
        >
          <TableCell colSpan={6} />
        </TableRow>
      )}
    </TableBody>
  );
};
